  export const environment = {
    environmentName: 'dev',
    apiUrl: '##{ApiUrl}##',
    production: false,
  };